import styled from "styled-components";

import { AppZIndex } from "../enums";
import { Color } from '@elearning-platform/ui';

export const SearchPopupWrapper = styled.div`
  position: fixed;
  inset: 0;
  background-color: ${Color.White100};
  z-index: ${AppZIndex.SearchBar};
  overflow-y: auto;
`;
